import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { Check, Info } from "lucide-react";

interface PricingTransparencyProps {
  serviceType: "photography" | "videography";
}

const PricingTransparency = ({ serviceType }: PricingTransparencyProps) => {
  const anim = useScrollAnimation();

  const photographyPrices = [
    {
      title: "Business-Porträts",
      price: "ab 1.000€",
      description: "Professionelle Unternehmensporträts für Teams und Führungskräfte"
    },
    {
      title: "Immobilienfotografie",
      price: "ab 1.000€",
      description: "Hochwertige Aufnahmen für Verkauf und Vermietung"
    },
    {
      title: "Event-Fotografie",
      price: "ab 1.500€",
      description: "Umfassende Dokumentation Ihrer Veranstaltung"
    },
    {
      title: "Produktfotografie",
      price: "Auf Anfrage",
      description: "Individuell kalkuliert nach Produktanzahl und Komplexität"
    }
  ];

  const videographyPrices = [
    {
      title: "Imagefilm",
      price: "ab 3.500€",
      description: "Professioneller Unternehmensfilm für Marketing und Kommunikation"
    },
    {
      title: "Werbefilm",
      price: "ab 3.500€",
      description: "Kreative Werbespots für TV, Kino und Online-Kanäle"
    },
    {
      title: "Event-Dokumentation",
      price: "ab 1.500€",
      description: "Professionelle Videodokumentation Ihrer Veranstaltung"
    }
  ];

  const prices = serviceType === "photography" ? photographyPrices : videographyPrices;

  return (
    <section className="section-padding bg-muted/20">
      <div
        ref={anim.ref}
        className={`container-custom transition-all duration-1000 ${
          anim.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
        }`}
      >
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Transparente Preisgestaltung
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg mb-6">
            Faire Preise für höchste Qualität in der Rhein-Neckar-Region
          </p>
          <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground bg-primary/5 border border-primary/20 rounded-lg p-4 max-w-3xl mx-auto">
            <Info className="w-5 h-5 text-primary flex-shrink-0" />
            <p>
              Wie beim Autokauf variieren Preise je nach Anforderungen. Die genannten Preise sind Startpunkte – das finale Angebot wird individuell auf Ihr Projekt abgestimmt.
            </p>
          </div>
        </div>

        <div className="bg-primary/5 border border-primary/20 rounded-2xl p-8 max-w-4xl mx-auto">
          <h3 className="text-xl font-semibold mb-4 text-center">Was ist immer inklusive?</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {[
              "Professionelle Beratung & Konzeption",
              "Professionelles Kamera-, Licht- und Tonequipment",
              "Professionelle Nachbearbeitung",
              "Unbegrenzte Revisions-Runden",
              "Alle Nutzungsrechte für kommerzielle Zwecke",
              "Schnelle Lieferung in hoher Qualität"
            ].map((feature, index) => (
              <div key={index} className="flex items-start gap-3">
                <Check className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                <span className="text-muted-foreground">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingTransparency;
